module.exports = __webpack_public_path__ + "static/media/upload-file.807d30e4.png";